
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/one-time-clean",
      function () {
        return require("private-next-pages/services/one-time-clean.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/one-time-clean"])
      });
    }
  